import { colors, glyphs } from "../../../Styles"

// #region | AnimalAnimation SVG
export function AnimalAnimation({size = "20px", fillColor = colors.greyLightTertiary}) {

  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283 351" cursor={"wait"}>
      <g transform="matrix(1,0,0,1,-2.125,-3.605)">
        <path d="M142.87,184.35C113.31,184.35 89.35,204.12 89.35,228.51C89.35,252.9 113.31,272.67 142.87,272.67C172.43,272.67 196.39,252.9 196.39,228.51C196.39,204.12 172.43,184.35 142.87,184.35ZM118.78,242.78C110.9,242.78 104.51,236.39 104.51,228.51C104.51,220.63 110.9,214.24 118.78,214.24C126.66,214.24 133.05,220.63 133.05,228.51C133.05,236.39 126.66,242.78 118.78,242.78ZM166.95,242.78C159.07,242.78 152.68,236.39 152.68,228.51C152.68,220.63 159.07,214.24 166.95,214.24C174.83,214.24 181.22,220.63 181.22,228.51C181.22,236.39 174.83,242.78 166.95,242.78Z"/>
      </g>
      <g transform="matrix(1,0,0,1,-2.125,-3.605)">
        <path d="M231.18,233.86C231.18,233.86 282.92,125.7 167.85,89.8C170.966,82.025 173.757,74.187 181.01,67.209C181.01,67.209 226.67,65.47 250.8,112.09C250.8,112.09 287.2,205.67 231.18,233.85L231.18,233.86Z" />
      </g>
      <g transform="matrix(-1,0,0,1,284.567,-3.605)">
        <path d="M231.18,233.86C231.18,233.86 282.92,125.7 167.85,89.8C170.966,82.025 173.757,74.187 181.01,67.209C181.01,67.209 226.67,65.47 250.8,112.09C250.8,112.09 287.2,205.67 231.18,233.85L231.18,233.86Z" />
      </g>

      {/* Right Ear */}
      <g transform="matrix(1,0,0,1,-2.125,-3.605)">
        <path>
          <animate
            attributeName="d"
            dur="3.8s"
            repeatCount="indefinite"
            calcMode="spline"
            keyTimes="0; 0.20; 1"
            keySplines="
              0.45 0 0.55 1;
              0.45 0 0.55 1
            "
            values="
            M250.8,112.09L224.944,125.7C208.98,106.948 192.983,97.068 167.85,89.8C167.85,89.8 178.56,50.98 226.72,42.52C265.67,35.68 255.26,17.54 255.26,17.54C255.26,17.54 309.67,59.47 250.8,112.09Z;

            M250.8,112.09L243.944,104.7C220.98,83.948 211.983,79.068 186.85,68.8C186.85,68.8 181.05,67.168 181.018,67.2C171.247,76.897 145.306,104.394 159.85,155.105C163.096,166.423 171.733,161.414 182.39,156.53C200.215,148.361 226.67,159.47 250.8,112.09Z;

            M250.8,112.09L224.944,125.7C208.98,106.948 192.983,97.068 167.85,89.8C167.85,89.8 178.56,50.98 226.72,42.52C265.67,35.68 255.26,17.54 255.26,17.54C255.26,17.54 309.67,59.47 250.8,112.09Z
            "
          />
        </path>
      </g>

      {/* Left Ear */}
      <g transform="matrix(-1,0,0,1,284.567,-3.605)">
        <path>
          <animate
            attributeName="d"
            dur="3.2s"
            repeatCount="indefinite"
            calcMode="spline"
            keyTimes="0; 0.20; 1"
            keySplines="
              0.45 0 0.55 1;
              0.45 0 0.55 1
            "
            values="
            M250.8,112.09L243.944,104.7C220.98,83.948 211.983,79.068 186.85,68.8C186.85,68.8 181.05,67.168 181.018,67.2C171.247,76.897 145.306,104.394 159.85,155.105C163.096,166.423 171.733,161.414 182.39,156.53C200.215,148.361 226.67,159.47 250.8,112.09Z;

            M250.8,112.09L224.944,125.7C208.98,106.948 192.983,97.068 167.85,89.8C167.85,89.8 178.56,50.98 226.72,42.52C265.67,35.68 255.26,17.54 255.26,17.54C255.26,17.54 309.67,59.47 250.8,112.09Z;

            M250.8,112.09L243.944,104.7C220.98,83.948 211.983,79.068 186.85,68.8C186.85,68.8 181.05,67.168 181.018,67.2C171.247,76.897 145.306,104.394 159.85,155.105C163.096,166.423 171.733,161.414 182.39,156.53C200.215,148.361 226.67,159.47 250.8,112.09Z
            "
          />
        </path>
      </g>

      {/* Dots */}
      <g transform="matrix(1.37135,0,0,1.37135,76.4191,-78.8617)">
        <circle cx="47.661" cy="288.894" r="13.894" fill={colors.greyTertiary}/>
        <animate
          attributeName="opacity"
          values="0.5;1;0.5"
          dur="1s"
          repeatCount="indefinite"
          begin="0s"
        />
      </g>
      <g transform="matrix(1.37135,0,0,1.37135,8.17103,-78.8617)">
       <circle cx="47.661" cy="288.894" r="13.894" fill={colors.greyTertiary}/>
        <animate
          attributeName="opacity"
          values="0.5;1;0.5"
          dur="1s"
          repeatCount="indefinite"
          begin="0.2s"
        />
      </g>
      <g transform="matrix(1.37135,0,0,1.37135,144.667,-78.8617)">
        <circle cx="47.661" cy="288.894" r="13.894" fill={colors.greyTertiary}/>
        <animate
          attributeName="opacity"
          values="0.5;1;0.5"
          dur="1s"
          repeatCount="indefinite"
          begin="0.4s"
        />
      </g>
    </svg>
  )
}
// #endregion

export function LoadingSpinner({size=50}:{size?:number}) {
  return (<AnimalAnimation fillColor={colors.piggyPink} size={`${size}px`}/>)
}